import React from 'react'
import Layout from '../components/layout'
import TabPage from '../components/TabPage/TabPageView';
import { StaticImage } from 'gatsby-plugin-image';





const TarievenIndex = (props) => {
  const tabPage1 = 
  <div style={{textAlign: 'left',textDecoration: 'underline', textDecorationColor: '#ff8e33'}} className='column tarieven_content_block'>
      <h3 >Pensionstalling</h3>
      <StaticImage placeholder='none' backgroundColor='#2b2b2f' alt='' src='../../static/PensionstallingAlgemeen.png' />
      <h3>Lessen</h3>
      <StaticImage placeholder='none' backgroundColor='#2b2b2f' alt='' src='../../static/LessenAlgemeen.png'/>
  </div>

const tabPage2 = 
<div style={{textAlign: 'left', textDecoration: 'underline', textDecorationColor: '#ff8e33'}} className='column tarieven_content_block'>
    <h3>Tarieven Pension</h3>
    <StaticImage placeholder='none' backgroundColor='#2b2b2f' alt='' src='../../static/PensionPagina.png'/>
</div>

const tabPage3 = 
<div  style={{textAlign: 'left', textDecoration: 'underline', textDecorationColor: '#ff8e33'}} className='column tarieven_content_block'>
    <h3 >Lessen</h3>
    <StaticImage placeholder='none' backgroundColor='#2b2b2f'  alt='' src='../../static/LessenPagina.png'/>

</div>

const tabPage4 = 
<div style={{textAlign: 'left', textDecoration: 'underline', textDecorationColor: '#ff8e33'}} className='column tarieven_content_block'>
    <h3 >Overig</h3>
    <StaticImage placeholder='none' backgroundColor='#2b2b2f' alt='' src='../../static/OverigPagina.png'/>
</div>



    return (
      <Layout title={"Tarieven"} location={props.location}>
        <div className='empty_box'></div>
        <h1 style={{textAlign: 'center'}}>Tarieven</h1>

        <TabPage tabNames={["Algemeen", "Pension", "Lessen", "Overig"]} tabContent={[tabPage1, tabPage2, tabPage3, tabPage4,]}/>

        

        


      </Layout>

    )
  }


export default TarievenIndex





